import * as types from './types'
import dataf from '../../data'

import { postcodeToDistrict, postcodeToLocality } from '../../dataUtils';
import config from '../../config';

const login = (email, password) => {
  return function (dispatch, getState) {
    fetch(`${config.api.prefix}api/login.php`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: JSON.stringify({
        email: email,
        password: password
      })
    }).then(res => res.json()).then(data => {
      if (data.status !== 200) {
        dispatch(loginFailure(data.message))
      } else {
        localStorage.setItem('logged', JSON.stringify({auth_time: data.data.last_login, auth_email: data.data.email, auth_token: data.data.access_token}))
        dispatch(loginSuccess(data.data))
        dispatch(getData())
        setTimeout(() => {
          dispatch(changeFilter())
        }, 1500)
      }
    }).catch((err) => {
      dispatch(loginFailure(err))
    })
  }
}

const loginSuccess = (data) => {
  return {type: types.LOGIN_SUCCESS, payload: data}
}

const loginFailure = (data) => {
  return {type: types.LOGIN_FAILURE, payload: data}
}

const logout = () => {
  localStorage.removeItem('logged')
  return {type: types.LOGOUT}
}

const clear = () => {
  return {type: types.CLEAR}
}

const changeFilter = (type = null, key = null, value = null) => {
  return function (dispatch, getState) {
    const d = getState().reports
    let d2 = JSON.parse(JSON.stringify(d))
    if (type != null && key != null && value != null) { d2.filter[type][key].selected = value }

    let raw = JSON.parse(JSON.stringify(d2.fetched))
    let filters = JSON.parse(JSON.stringify(d2.filter))
    let postcodeToLocalitys = postcodeToLocality()
    let postcodeToDistricts = postcodeToDistrict()
    let final = raw.filter((item) => {
      if (
          // AGE
          ((filters.age[0].selected && item.age_range === filters.age[0].name)
          || (filters.age[1].selected && item.age_range === filters.age[1].name)
          || (filters.age[2].selected && item.age_range === filters.age[2].name)
          || (filters.age[3].selected && item.age_range === filters.age[3].name)
          || (filters.age[4].selected && item.age_range === filters.age[4].name)
          || (!filters.age[0].selected && !filters.age[1].selected && !filters.age[2].selected && !filters.age[3].selected && !filters.age[4].selected))
          &&
          // GENDER
          ((filters.gender[0].selected && item.gender === filters.gender[0].key)
          || (filters.gender[1].selected && item.gender === filters.gender[1].key)
          || (filters.gender[2].selected && item.gender === filters.gender[2].key)
          || (filters.gender[3].selected && item.gender === filters.gender[3].key)
          || (!filters.gender[0].selected && !filters.gender[1].selected && !filters.gender[2].selected && !filters.gender[3].selected))
          &&
          // LOCALITY
          ((filters.locality[0].selected && (postcodeToDistricts[item.postal_code.toUpperCase()] && postcodeToLocalitys[item.postal_code.toUpperCase()].key === filters.locality[0].key))
          || (filters.locality[1].selected && (postcodeToDistricts[item.postal_code.toUpperCase()] && postcodeToLocalitys[item.postal_code.toUpperCase()].key === filters.locality[1].key))
          || (filters.locality[2].selected && (postcodeToDistricts[item.postal_code.toUpperCase()] && postcodeToLocalitys[item.postal_code.toUpperCase()].key === filters.locality[2].key))
          || (filters.locality[3].selected && (postcodeToDistricts[item.postal_code.toUpperCase()] && postcodeToLocalitys[item.postal_code.toUpperCase()].key === filters.locality[3].key))
          || (filters.locality[4].selected && (postcodeToDistricts[item.postal_code.toUpperCase()] && postcodeToLocalitys[item.postal_code.toUpperCase()].key === filters.locality[4].key))
          || (filters.locality[5].selected && (postcodeToDistricts[item.postal_code.toUpperCase()] && postcodeToLocalitys[item.postal_code.toUpperCase()].key === filters.locality[5].key))
          || (filters.locality[6].selected && (postcodeToDistricts[item.postal_code.toUpperCase()] && postcodeToLocalitys[item.postal_code.toUpperCase()].key === filters.locality[6].key))
          || (filters.locality[7].selected && (postcodeToDistricts[item.postal_code.toUpperCase()] && postcodeToLocalitys[item.postal_code.toUpperCase()].key === filters.locality[7].key))
          || (filters.locality[8].selected && (postcodeToDistricts[item.postal_code.toUpperCase()] && postcodeToLocalitys[item.postal_code.toUpperCase()].key === filters.locality[8].key))
          || (filters.locality[9].selected && (postcodeToDistricts[item.postal_code.toUpperCase()] && postcodeToLocalitys[item.postal_code.toUpperCase()].key === filters.locality[9].key))
          || (filters.locality[10].selected && (postcodeToDistricts[item.postal_code.toUpperCase()] && postcodeToLocalitys[item.postal_code.toUpperCase()].key === filters.locality[10].key))
          || (filters.locality[11].selected && (postcodeToDistricts[item.postal_code.toUpperCase()] && postcodeToLocalitys[item.postal_code.toUpperCase()].key === filters.locality[11].key))
          || (filters.locality[12].selected && (postcodeToDistricts[item.postal_code.toUpperCase()] && postcodeToLocalitys[item.postal_code.toUpperCase()].key === filters.locality[12].key))
          || (filters.locality[13].selected && (postcodeToDistricts[item.postal_code.toUpperCase()] && postcodeToLocalitys[item.postal_code.toUpperCase()].key === filters.locality[13].key))
          || (filters.locality[14].selected && (postcodeToDistricts[item.postal_code.toUpperCase()] && postcodeToLocalitys[item.postal_code.toUpperCase()].key === filters.locality[14].key))
          || (filters.locality[15].selected && (postcodeToDistricts[item.postal_code.toUpperCase()] && postcodeToLocalitys[item.postal_code.toUpperCase()].key === filters.locality[15].key))
          || (filters.locality[16].selected && (postcodeToDistricts[item.postal_code.toUpperCase()] && postcodeToLocalitys[item.postal_code.toUpperCase()].key === filters.locality[16].key))
          || (filters.locality[17].selected && (postcodeToDistricts[item.postal_code.toUpperCase()] && postcodeToLocalitys[item.postal_code.toUpperCase()].key === filters.locality[17].key))
          || (filters.locality[18].selected && (postcodeToDistricts[item.postal_code.toUpperCase()] && postcodeToLocalitys[item.postal_code.toUpperCase()].key === filters.locality[18].key))
          || (filters.locality[19].selected && (postcodeToDistricts[item.postal_code.toUpperCase()] && postcodeToLocalitys[item.postal_code.toUpperCase()].key === filters.locality[19].key))
          || (filters.locality[20].selected && (postcodeToDistricts[item.postal_code.toUpperCase()] && postcodeToLocalitys[item.postal_code.toUpperCase()].key === filters.locality[20].key))
          || (filters.locality[21].selected && (postcodeToDistricts[item.postal_code.toUpperCase()] && postcodeToLocalitys[item.postal_code.toUpperCase()].key === filters.locality[21].key))
          || (filters.locality[22].selected && (postcodeToDistricts[item.postal_code.toUpperCase()] && postcodeToLocalitys[item.postal_code.toUpperCase()].key === filters.locality[22].key))
          || (filters.locality[23].selected && (postcodeToDistricts[item.postal_code.toUpperCase()] && postcodeToLocalitys[item.postal_code.toUpperCase()].key === filters.locality[23].key))
          || (filters.locality[24].selected && (postcodeToDistricts[item.postal_code.toUpperCase()] && postcodeToLocalitys[item.postal_code.toUpperCase()].key === filters.locality[24].key))
          || (filters.locality[25].selected && (postcodeToDistricts[item.postal_code.toUpperCase()] && postcodeToLocalitys[item.postal_code.toUpperCase()].key === filters.locality[25].key))
          || (filters.locality[26].selected && (postcodeToDistricts[item.postal_code.toUpperCase()] && postcodeToLocalitys[item.postal_code.toUpperCase()].key === filters.locality[26].key))
          || (
            !filters.locality[0].selected &&
            !filters.locality[1].selected &&
            !filters.locality[2].selected &&
            !filters.locality[3].selected &&
            !filters.locality[4].selected &&
            !filters.locality[5].selected &&
            !filters.locality[6].selected &&
            !filters.locality[7].selected &&
            !filters.locality[8].selected &&
            !filters.locality[9].selected &&
            !filters.locality[10].selected &&
            !filters.locality[11].selected &&
            !filters.locality[12].selected &&
            !filters.locality[13].selected &&
            !filters.locality[14].selected &&
            !filters.locality[15].selected &&
            !filters.locality[16].selected &&
            !filters.locality[17].selected &&
            !filters.locality[18].selected &&
            !filters.locality[19].selected &&
            !filters.locality[20].selected &&
            !filters.locality[21].selected &&
            !filters.locality[22].selected &&
            !filters.locality[23].selected &&
            !filters.locality[24].selected &&
            !filters.locality[25].selected &&
            !filters.locality[26].selected
          ))
          &&
          // POSTAL
          ((filters.postal[0].selected && postcodeToDistricts[item.postal_code.toUpperCase()] === filters.postal[0].name)
          || (filters.postal[1].selected && postcodeToDistricts[item.postal_code.toUpperCase()] === filters.postal[1].name)
          || (filters.postal[2].selected && postcodeToDistricts[item.postal_code.toUpperCase()] === filters.postal[2].name)
          || (filters.postal[3].selected && postcodeToDistricts[item.postal_code.toUpperCase()] === filters.postal[3].name)
          || (filters.postal[4].selected && postcodeToDistricts[item.postal_code.toUpperCase()] === filters.postal[4].name)
          || (filters.postal[5].selected && postcodeToDistricts[item.postal_code.toUpperCase()] === filters.postal[5].name)
          || (filters.postal[6].selected && postcodeToDistricts[item.postal_code.toUpperCase()] === filters.postal[6].name)
          || (filters.postal[7].selected && postcodeToDistricts[item.postal_code.toUpperCase()] === filters.postal[7].name)
          || (filters.postal[8].selected && postcodeToDistricts[item.postal_code.toUpperCase()] === filters.postal[8].name)
          || (filters.postal[9].selected && postcodeToDistricts[item.postal_code.toUpperCase()] === filters.postal[9].name)
          || (filters.postal[10].selected && postcodeToDistricts[item.postal_code.toUpperCase()] === filters.postal[10].name)
          || (filters.postal[11].selected && postcodeToDistricts[item.postal_code.toUpperCase()] === filters.postal[11].name)
          || (filters.postal[12].selected && postcodeToDistricts[item.postal_code.toUpperCase()] === filters.postal[12].name)
          || (
            !filters.postal[0].selected
            && !filters.postal[1].selected
            && !filters.postal[2].selected
            && !filters.postal[3].selected
            && !filters.postal[4].selected
            && !filters.postal[5].selected
            && !filters.postal[6].selected
            && !filters.postal[7].selected
            && !filters.postal[8].selected
            && !filters.postal[9].selected
            && !filters.postal[10].selected
            && !filters.postal[11].selected
            && !filters.postal[12].selected
          ))
      ) {
        return item
      } else {
        return null
      }
    })

    d2.displayed.spending_areas = final.length > 0 ? {
      adult_social_care: final.reduce((prev, elem) => { return prev + (isNaN(elem.adult_social_care) ? 0 : Number(elem.adult_social_care)) }, 0) / final.length || 0,
      children_social_care: final.reduce((prev, elem) => { return prev + (isNaN(elem.children_social_care) ? 0 : Number(elem.children_social_care)) }, 0) / final.length || 0,
      refuse_waste_collection_disposal: final.reduce((prev, elem) => { return prev + (isNaN(elem.refuse_waste_collection_disposal) ? 0 : Number(elem.refuse_waste_collection_disposal)) }, 0) / final.length || 0,
      education_early_years: final.reduce((prev, elem) => { return prev + (isNaN(elem.education_early_years) ? 0 : Number(elem.education_early_years)) }, 0) / final.length || 0,
      culture_leisure_libraries: final.reduce((prev, elem) => { return prev + (isNaN(elem.culture_leisure_libraries) ? 0 : Number(elem.culture_leisure_libraries)) }, 0) / final.length || 0,
      maintaining_highways_parking: final.reduce((prev, elem) => { return prev + (isNaN(elem.maintaining_highways_parking) ? 0 : Number(elem.maintaining_highways_parking)) }, 0) / final.length || 0,
      maintaining_neighbourhoods: final.reduce((prev, elem) => { return prev + (isNaN(elem.maintaining_neighbourhoods) ? 0 : Number(elem.maintaining_neighbourhoods)) }, 0) / final.length || 0,
      planning_and_development: final.reduce((prev, elem) => { return prev + (isNaN(elem.planning_and_development) ? 0 : Number(elem.planning_and_development)) }, 0) / final.length || 0,
      public_health: final.reduce((prev, elem) => { return prev + (isNaN(elem.public_health) ? 0 : Number(elem.public_health)) }, 0) / final.length || 0,
      business_econ_development: final.reduce((prev, elem) => { return prev + (isNaN(elem.business_econ_development) ? 0 : Number(elem.business_econ_development)) }, 0) / final.length || 0,
      enforcement_and_regulation: final.reduce((prev, elem) => { return prev + (isNaN(elem.enforcement_and_regulation) ? 0 : Number(elem.enforcement_and_regulation)) }, 0) / final.length || 0,
      core_business_functions: final.reduce((prev, elem) => { return prev + (isNaN(elem.core_business_functions) ? 0 : Number(elem.core_business_functions)) }, 0) / final.length || 0,
    } : []

    /**
     * The actual values returned by the calculation to get the mean spending area values
     * differs to what is returned by the API. This is because the calculation is slightly different.
     * Here we are matching the calculation supplied by the API to ensure values are consistent, as per the request
     * of the client.
     */
    const roundedSpendingAreas = Object.keys(d2.displayed.spending_areas).map(area => ({ area, value: Math.ceil(d2.displayed.spending_areas[area] / 100000) * 100000 } ));
    const mappedSpendingAreas = roundedSpendingAreas.map(item => ({ [item.area]: item.value }));
    const updatedSpendingAreas = Object.assign({}, ...mappedSpendingAreas);

    d2.displayed.spending_areas = updatedSpendingAreas;

    d2.displayed.council_1 = final.length > 0 ? final.reduce((prev, elem) => { return prev + (isNaN(elem.council_1) ? 0 : Number(elem.council_1)) }, 0) / final.length || 0 : 0
    d2.displayed.council_2 = final.length > 0 ? final.reduce((prev, elem) => { return prev + (isNaN(elem.council_2) ? 0 : Number(elem.council_2)) }, 0) / final.length || 0 : 0
    d2.displayed.council_3 = final.length > 0 ? final.reduce((prev, elem) => { return prev + (isNaN(elem.council_3) ? 0 : Number(elem.council_3)) }, 0) / final.length || 0 : 0
    d2.displayed.council_4 = final.length > 0 ? final.reduce((prev, elem) => { return prev + (isNaN(elem.council_4) ? 0 : Number(elem.council_4)) }, 0) / final.length || 0 : 0

    d2.displayed.total_spend = 0
    d2.displayed.low_risk_budgets = 0
    d2.displayed.high_risk_budgets = 0

    final.length > 0 ? Object.keys(d2.displayed.spending_areas).map((index, elem) => { // eslint-disable-line no-unused-expressions
      d2.displayed.total_spend = d2.displayed.total_spend + Number(d2.displayed.spending_areas[index]);

      if (d2.displayed.spending_areas[index] < (dataf.spending_areas[elem].max * 0.9)) {
        d2.displayed.high_risk_budgets = d2.displayed.high_risk_budgets + 1
      }
      if (d2.displayed.spending_areas[index] < (dataf.spending_areas[elem].max) && d2.displayed.spending_areas[index] > (dataf.spending_areas[elem].max * 0.95)) {
        d2.displayed.low_risk_budgets = d2.displayed.low_risk_budgets + 1
      }
      return true
    }) : null

    // d2.displayed.council_tax = final.length > 0 ? Math.round((final.reduce((prev, elem) => { return prev + (isNaN(elem.council_tax) ? 0 : Number(elem.council_tax)) }, 0) / final.length || 0) / 580000) * 580000 : 0

    d2.displayed.council_tax = final.length > 0
      ? Math.round((final.reduce((prev, elem) => { return prev + (isNaN(elem.council_tax) ? 0 : Number(elem.council_tax)) }, 0) / final.length))
      : 0;

    d2.displayed.council_tax_percent = final.length > 0 ? Math.round((final.reduce((prev, elem) => { return prev + (isNaN(elem.council_tax) ? 0 : Number(elem.council_tax)) }, 0) / final.length || 0) / 580000) : 0
    d2.displayed.budgets_submitted = final.length > 0 ? final.length : 0
    d2.comments = []

    final.map((item) => {
      d2.comments.push(item.budget_reason)
      return true
    });

    // Return the filters that have been selected.
    // But also assign the type to the object so we can use this in the UI.
    let selected_filters = Object.keys(d2.filter).map(item => {
      return d2.filter[item].filter(
        i => {
          i.type = item;
          return i.selected === true;
        }
      );
    });

    selected_filters = selected_filters.filter(filters => filters.length > 0);

    d2.selected_filters = selected_filters;

    dispatch(changeFilterSuccess(d2))
  }
}

const changeFilterSuccess = (data) => {
  return {type: types.CHANGE_FILTER, payload: data}
}

const getData = () => {
  return function (dispatch, getState) {
    let email = getState().reports.auth.auth_email
    let token = getState().reports.auth.auth_token
    fetch(`${config.api.prefix}api/query.php`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: JSON.stringify({
        email: email,
        token: token
      })
    }).then(res => res.json()).then(data => {
      if (data.status === 200) {
        dispatch(_GETDATA(data.data))
      } else {
        dispatch(logout())
      }
    }).catch((err) => {
      // dispatch(_LOGIN_FAILURE(err))
    })
  }
}

const _GETDATA = (data) => {
  return {type: types.QUERY, payload: data}
}

const setGiveUpComments = (data) => {
  return {
    type: types.SET_GIVE_UP_COMMENTS,
    payload: data,
  }
}

const getGiveUpComments = () => {
  return (dispatch, getState) => {
    fetch(`${config.api.prefix}api/getGaveUpReasons.php`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json'
      }
    }).then(res => res.json()).then(data => {
      dispatch(setGiveUpComments(data.message));
    });
  }
}

export {
  login,
  loginSuccess,
  loginFailure,
  logout,
  clear,
  changeFilter,
  changeFilterSuccess,
  getData,
  getGiveUpComments,
  _GETDATA
}



// WEBPACK FOOTER //
// ./src/reducks/reports/actions.js